import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Row, Spinner, Input } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useTranslation } from "react-i18next";
import { getAuthUser } from "../../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import { fetchGPATableColumnNames, fetchAllGPA, createGPA, updateGPA, 
    deleteGPA, activateDeactivateGPA, updateUserPreference} from "../../../slices/thunks";
import ColumnSelectionModal from "../../../Components/Common/ColumnSelectionModal/ColumnSelectionModal";
import CommonTable from "../../../Components/Common/Table/CommonTable";
import DeleteModal from "../../../Components/Common/DeleteModal";
import AddModal from "../../../Components/Common/Modal/AddModal";
import AddCommonForm2 from "../../../Components/Common/AddCommonForm/AddCommonForm2";
import CommonDataTable from "../../../Components/Common/Table/CommonDataTable";
import AddCommonForm from "../../../Components/Common/AddCommonForm/AddCommonForm";
import CommonAddModal from "../../../Components/Common/Modal/CommonAddModal";


const labels = [
  {
    id: 1,
    labelName: "From",
    fieldName: "number-box",
    name: "MinPercentage",
    value: "MinPercentage",
    required: true,
    errorMessage: "Please Enter From"
  },
  {
    id: 2,
    labelName: "To",
    fieldName: "number-box",
    name: "MaxPercentage",
    value: "MaxPercentage",
    required: true,
    errorMessage: "Please Enter To"
  },
  {
    id: 3,
    labelName: "GPA",
    fieldName: "number-box",
    name: "GPA",
    value: "GPA",
    required: true,
    errorMessage: "Please Enter GPA"
  },
  {
    id: 4,
    labelName: "Grade",
    fieldName: "text-box",
    name: "Grade",
    value: "Grade",
    required: true,
    errorMessage: "Please Enter Grade"
  }
]

const actionConfig = {
  edit: {
    icon: "ri-edit-2-line",
    tooltip: "Edit",
  },
  delete: {
    icon: "ri-delete-bin-2-line",
    tooltip: "Delete",
  },
};


function GPA () {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const user = getAuthUser();
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddOrEdit, setIsAddOrEdit] = useState("isAdd");
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);

  const { GPA, tableColumnNames, loading, Headerload, module } = useSelector((state) => ({
    GPA: state.GPA.gpa,
    tableColumnNames: state.GPA.tableColumnNames,
    loading: state.GPA.loading,
    Headerload: state.GPA.Headerload,
    module: state.Module.module,
  }));

  // Compute permission
  const permission = (() => {
    const moduleItem = module?.find((m) => m.moduleId === 3 && m.modulePermission?.CanView);
    const pageItem = moduleItem?.pages?.find((p) => p.pageId === 19); // Roles Management = pageId: 2
        
      if (moduleItem && pageItem) {
        return {
          CanView:
            moduleItem.modulePermission.CanView && pageItem.permissions.CanView,
          CanAdd:
            moduleItem.modulePermission.CanAdd && pageItem.permissions.CanAdd,
          CanEdit:
            moduleItem.modulePermission.CanEdit && pageItem.permissions.CanEdit,
          CanDelete:
            moduleItem.modulePermission.CanDelete && pageItem.permissions.CanDelete,
          CanActive:
            moduleItem.modulePermission.CanActive && pageItem.permissions.CanActive,
        };
      }
    
    return {};
  })();

  const onAddClickHandler = (value) => {
    setShow(true);
    setIsAddOrEdit(value);
    setSelectedRow({});
  };

  const onEditClickHandler = (GPA, value) => {
    setSelectedRow(GPA);
    setIsAddOrEdit(value);
    setShow(true);
  };
  
  const onChangeHandler = (e) => {
    const { name, value } = e.target;

    setSelectedRow((prev) => ({
      ...prev,
      [name]: value
    }));
  };
  
  
  const onSubmitHandler = (values, { resetForm }) => {

    const GPAObj = {
      MinPercentage: values.MinPercentage,
      MaxPercentage: values.MaxPercentage,
      GPA: values.GPA,
      Grade: values.Grade,
    };

    if (isAddOrEdit === "isEdit") {
        GPAObj.ID = selectedRow?.ID;
    }

    isAddOrEdit === "isAdd" ?
      dispatch(createGPA(GPAObj)) :
      dispatch(updateGPA(GPAObj));

    resetForm();
    setShow(false);
  };

  const handleSave = async () => {
    const preferencesPayload = {
      UserId: user.UserId,
      ColumnIDs: tableColumnNames.reduce((acc, column) => {
        acc[column.ColumnId] = selectedColumns.includes(column.ColumnId);
        return acc;
      }, {}),
    };

    setModalOpen(false);

    try {
      await dispatch(updateUserPreference(preferencesPayload)).unwrap();
      await     dispatch(fetchGPATableColumnNames({ module: "GPA" }))
      await dispatch(fetchAllGPA({module: "GPA"})
      );

    } catch (error) {
      console.error("Error updating preferences:", error);
    }
  };

  const confirmDelete = () => {
    dispatch(deleteGPA({ Ids: selectedIds, UserId: user.UserId }))
      .then(() => {
        setSelectedIds([]);
      })
      .catch((error) => {
        console.error("Error deleting:", error);
      });
    setDeleteModal(false);
  };

  const onActiveOrDeactiveChange = (GPA, e) => {
    dispatch(activateDeactivateGPA({ ID: GPA.ID, IsActive: GPA.IsActive, UserId: user.UserId }));
  };

  useEffect(() => {
    dispatch(fetchGPATableColumnNames({ module: "GPA" }))
    dispatch(fetchAllGPA({ Type: 2 }));

  }, [dispatch]);

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t('GPA Configuration')} />
          </Col>
        </Row>
        <div className="table-responsive">
          <Card>
            <CardHeader>
              <Row className="g-4 ">
                  <Col className="col-sm-auto">
                    <div>
                      <Button
                        className="btn btn-soft-danger ms-2 me-2"
                        onClick={() => setDeleteModal(true)}
                        disabled={selectedIds.length === 0}
                      >
                        <i className="ri-delete-bin-2-line"></i>
                      </Button>
                      {permission.CanAdd && (
                        <Button
                          color="secondary"
                          className="add-btn me-1"
                          onClick={() => onAddClickHandler("isAdd")}
                          id="create-btn"
                          disabled={loading}
                        >
                          <i className="ri-add-line align-bottom me-1 ms-1"></i>
                          {t("AddNew")}
                        </Button>
                      )}
                    </div>
                  </Col>
                  <Col className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <Button
                        className="btn btn-soft"
                        onClick={() => setModalOpen(true)}
                        disabled={loading}
                      >
                        <i className="ri-filter-3-line"></i>
                      </Button>
                      <div className="search-box ms-2 me-2">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder={t("Search")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </Col>
              </Row>            
            </CardHeader>

            <CardBody>
              <div className="listjs-table" id="customerList">
                {loading || Headerload ? (
                  <div className="d-flex justify-content-center align-items-center">
                  <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                    Loading...
                  </Spinner>
                  </div>
                ) : (
                  <div className="listjs-table" id="customerList">
                    {/* <CommonTable
                      data={GPA}
                      tableColumnNames={tableColumnNames}
                      searchTerm={searchTerm}
                      onEditClickHandler={onEditClickHandler}
                      onActiveOrDeactiveChange={onActiveOrDeactiveChange}
                      setDeleteModal={setDeleteModal}
                      setSelectedIds={setSelectedIds}
                      hasAction={true}
                      permission={permission}
                    /> */}
                    <CommonDataTable
                      data={GPA}
                      tableColumnNames={tableColumnNames}
                      searchTerm={searchTerm}
                      onEditClickHandler={onEditClickHandler}
                      onActiveOrDeactiveChange={onActiveOrDeactiveChange}
                      setDeleteModal={setDeleteModal}
                      setSelectedIds={setSelectedIds}
                      actionConfig={actionConfig}
                      permission={permission}
                    />
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>

      {/* Modal  */}
      <CommonAddModal
          show={show}
          setShow={setShow}
          onSubmitHandler={onSubmitHandler}
          labels={labels}
          isAddOrEdit={isAddOrEdit}
          selectedItemData={selectedRow}
          FormBody={AddCommonForm}
          // FormBodyProps={{ onTranslateClickHandler, translationLoading, lastTranslatedField }} 
          title={isAddOrEdit === "isAdd" ? t("Add New GPA") : t("Edit GPA")} 
          size="lg"
        />

      {/* ColumnSelectionModal */}
      <ColumnSelectionModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        columns={tableColumnNames}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        handleSave={handleSave}
      />

      {/* Delete modal  */}
      <DeleteModal
        showDelete={deleteModal}
        setShowDelete={setDeleteModal}
        onDeleteClick={confirmDelete}
        setSelectedIds={setSelectedIds}
        description={`Are you sure you want to delete this record?`}
      />
    </div>
  );
}

export default GPA;